// extracted by mini-css-extract-plugin
export default {"error_wrap":"ErrorPage_error_wrap__D9CUV","error_title":"ErrorPage_error_title__THA97","error_wrap_button":"ErrorPage_error_wrap_button__n8mvm"};